import MediaManagement from "./media-management.page";

export default MediaManagement;
